const isObjectEmpty = (obj) => Object.keys(obj).length === 0;

export default isObjectEmpty;
